import type { Element } from "@app/types/Cue";
import { PAYWALL_TREATMENTS_TRUNCATE_LENGTHS } from "@util/constant";

export function calculateLengthToTruncateBeforeDisplayingPaywall(
  contentLength: number
): number {
  const config = PAYWALL_TREATMENTS_TRUNCATE_LENGTHS;
  // @TODO Avoid mutation.
  let truncatedLength = config[0]?.paywallCharLength;

  for (const { paywallCharLength, storyCharLength } of config) {
    const [min, max] = storyCharLength;

    if (min && max) {
      if (contentLength >= min && contentLength < max) {
        truncatedLength = paywallCharLength;
        break;
      }
    }
  }

  return truncatedLength;
}

export function calculateTotalContentLength(content: Element[]): number {
  let totalContentLength = 0;

  content.forEach((element) => {
    if (element.type === "paragraph") {
      const paragraphText = element.fields?.[0]?.value;

      totalContentLength += paragraphText?.length || 0;
    }
  });

  return totalContentLength;
}
